import { useQuery } from "react-query";
import servicesUtils from "../../../utils/servicesUtils";
var useGetReport = function useGetReport(isOpen) {
  return useQuery(["reportTemplate", isOpen], function () {
    return servicesUtils.getService("/report_templates/");
  }, {
    enabled: isOpen
  });
};
export default useGetReport;